<template>
  <div class="page">
    <div class="container">
      <h4 class="title">中国职业教育质量年度报告满意度调查服务系统</h4>

      <el-form
        v-if="step == 2"
        v-loading="step2Loading"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-position="top"
        label-width="180px"
      >
        <div>
          <el-form-item
            v-for="(item, index) in surveyFormFieldInfoList"
            :key="item.id"
            :label="`${index + 1}.${item.fieldName}`"
            class="form-item"
            :prop="item.fieldCode"
          >
            <dl v-if="item.type == 1">
              <!--    固定id 且选择了否的时候 禁用  -->
              <el-radio
                v-for="(it, index) in item.surveyFieldOptionList"
                :key="index"
                v-model="ruleForm[item.fieldCode]"
                @input="radioClick(item)"
                :disabled="item.fieldCode === 'accommodation' && ruleForm.is_boarder && ruleForm.is_boarder === '否'"
                :label="it.name"
                class="radio-option"
              >
                {{ it.name }}
              </el-radio>

              <div v-if="ruleForm[item.fieldCode] === '其他'" style="width: 200px; display: inline-block">
                <el-input v-model="item.other" placeholder="请输入内容"></el-input>
              </div>
            </dl>

            <dl v-if="item.type == 2">
              <el-checkbox-group v-model="ruleForm[item.fieldCode]" @change="checkboxChange($event, index, item)">
                <el-checkbox v-for="(it, index) in item.surveyFieldOptionList" :key="index" :label="it.name" />
                <div v-if="ruleForm[item.fieldCode].indexOf('其他') !== -1" style="width: 100px; display: inline-block">
                  <div style="display: flex; width: 300px; margin-left: 20px">
                    <el-input v-model="item.other" placeholder="请输入内容" style="width: 200px"> </el-input>
                  </div>
                </div>
              </el-checkbox-group>
            </dl>

            <dl v-if="item.type == 3">
              <!--   这里绑定了三个变量  两个单选框为一个变量  级联选择器为一个变量 el-input为一个变量-->
              <el-radio v-model="ruleForm[item.fieldCode]" label=" " @input="item.other = ''"> </el-radio>

              <div class="cascader_box" style="display: inline-block">
                <el-cascader
                  v-model="item.value"
                  :options="item.options"
                  :props="{
                    label: 'name',
                    value: 'code',
                    children: 'child'
                  }"
                  :disabled="ruleForm[item.fieldCode] === '其他'"
                  @focus="cascaderFocus(item, index)"
                  @change="cascaderChange($event, item)"
                  filterable
                  v-if="ruleForm[item.fieldCode]"
                >
                </el-cascader>
                <div v-else>请点击</div>
              </div>
              <el-radio
                v-model="ruleForm[item.fieldCode]"
                label="其他"
                style="margin-left: 20px"
                @input="
                  item.value = [];
                  $forceUpdate();
                "
              ></el-radio>

              <div v-if="ruleForm[item.fieldCode] === '其他'" style="display: inline-block">
                <el-input v-model="item.other" placeholder="请输入内容"></el-input>
              </div>
            </dl>

            <dl v-if="item.type == 4">
              <el-input v-model="ruleForm[item.fieldCode]" placeholder="请输入内容" style="width: 60%"></el-input>
            </dl>

            <dl v-if="item.type == 5">
              <div class="matrix-question">
                <table class="matrix-table">
                  <thead>
                    <tr>
                      <th style="width: 200px"></th>
                      <th
                        v-for="(option, optIndex) in item.surveyFieldOptionList"
                        :key="optIndex"
                        style="text-align: center"
                      >
                        {{ option.name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(dimension, dimIndex) in item.surveyFieldMatrixDimensionList" :key="dimIndex">
                      <td class="dimension-name">{{ dimension.name }}</td>
                      <td
                        v-for="(option, optIndex) in item.surveyFieldOptionList"
                        :key="option.id"
                        style="text-align: center; width: 100px"
                      >
                        <el-radio v-model="dimension.value" :label="option.name">&nbsp;</el-radio>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </dl>
          </el-form-item>
        </div>
      </el-form>
      <el-button v-if="step == 2" :disabled="success" type="primary" @click="doClickSubmit">提交问卷</el-button>
      <div style="height: 20px"></div>
      <div v-if="step == 3">
        <el-result icon="success" subTitle="">
          <template slot="extra">
            <div style="font-size: 20px">
              <div v-if="isTeacher">
                填报完成，感谢您的支持。如果有时间，可以继续浏览<a href="http://edu.zwdn.com/"
                  >全国职业教育质量年度报告</a
                >
              </div>
              <div v-else>填答结束，非常感谢您参与我们的调查！</div>
            </div>
          </template>
        </el-result>
        <div style="margin: 10%; text-align: center"></div>
      </div>
    </div>

    <el-dialog title="请滑动拼图" :visible.sync="dialogVisible">
      <div style="display: flex; justify-content: center; align-items: center">
        <slideVerify
          ref="slideblock"
          :w="fullWidth"
          :h="fullHeight"
          :accuracy="accuracy"
          :slider-text="text"
          :imgs="imgList"
          :phone="phone"
          :queryForm="queryForm"
          :formId="formId"
          @again="onAgain"
          @fulfilled="onFulfilled"
          @handelSuccess="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAnswer, submit } from '@/api/answer.js';
import SlideVerify from '@/components/slideVerify/index.vue';

export default {
  components: {
    SlideVerify
  },
  data() {
    return {
      surveyFormFieldInfoList: [],
      allQuestions: [], // 完整的题目列表（包括隐藏的）
      visibleQuestionIds: [], // 可见的题目 ID 列表
      options: [],
      // 发布问卷相关
      issueDialogVisible: false,
      issueQuery: {
        collegeType: '',
        id: ''
      },
      ruleForm: {},
      // 校验
      rules: {},
      formId: '213',
      queryForm: {
        collegeId: '',
        formCode: '',
        formName: '',
        status: 2,
        surveyFormDataList: [],
        verificationCode: '',
        s: ''
      },
      step2Loading: false,
      success: false,
      step: 2,
      phone: null,
      dialogVisible: false,
      // 滑块相关
      fullWidth: 300,
      fullHeight: 304,
      msg: '',
      text: '请向右滑动滑块完成验证',
      // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      accuracy: 3,
      imgList: [require('@/assets/image/verify_2x.png')],
      isTeacher: false
    };
  },

  watch: {
    '$route.query': {
      handler(query) {
        this.queryForm.collegeId = query.collegeId;
        this.formId = query.formId;
        this.queryForm.s = query.s;
        this.phone = query.phone;
        this.queryForm.phone = query.phone;
        // this.getDetail();
      },
      immediate: true
    }
  },

  mounted() {
    if (!this.formId) {
      this.$message.error('系统异常，请退出重试');
      this.$router.replace({
        path: '/index',
        query: this.$route.query
      });
      return;
    }

    if (!this.phone) {
      this.$message.warning('请先在须知页完成手机号校验');
      this.$router.replace({
        path: '/index',
        query: this.$route.query
      });
      return;
    }

    // 判断用户类别
    this.checkUserType();
    this.getDetail();
    // this.queryForm.startTime = new Date().getTime()
    // const endTime = 1702742400000
    // // 截止时间
    // if (this.queryForm.startTime >= endTime) {
    //   this.step = 3
    //   this.dialogVisible = true
    // }
  },
  methods: {
    checkUserType() {
      const { userType } = this.$route.query;
      if (userType) {
        this.isTeacher = userType === 'teacher';
        return;
      }

      // 兜底：兼容未经过欢迎页直接访问 /answer 的场景
      const teacherFormIds = ['17'];
      this.isTeacher = teacherFormIds.includes(String(this.formId));
    },
    checkboxChange(e, index, item) {
      // 多选改变时，重新检查所有题目的可见性
      this.updateVisibleQuestions();
    },
    radioClick(item) {
      if (item.fieldCode === 'is_boarder' && this.ruleForm.is_boarder && this.ruleForm.is_boarder === '否') {
        this.ruleForm.accommodation = '';
      }
      // 单选改变时，重新检查所有题目的可见性
      this.updateVisibleQuestions();
      this.$forceUpdate();
    },

    getDetail() {
      // TODO: 测试完成后删除此开关，恢复后端接口调用
      const useMockData = false; // 设置为 true 使用模拟数据，false 使用后端接口

      if (useMockData) {
        // 使用模拟数据测试
        this.loadMockData();
      } else {
        // 调用后端接口
        getAnswer({
          id: this.formId,
          collegeId: this.queryForm.collegeId,
          s: this.queryForm.s,
          phone: this.queryForm.phone
        }).then(res => {
          const { surveyFormFieldInfoList, formName, formCode } = res.data.data;
          this.queryForm.formCode = formCode;
          this.queryForm.formName = formName;
          this.processSurveyData(surveyFormFieldInfoList);
        });
      }
    },

    // 加载模拟数据
    loadMockData() {
      const mockSurveyFormFieldInfoList = [
        {
          id: 1,
          rowId: 1,
          fieldName: '您的性别是？',
          fieldCode: 'gender',
          type: 1, // 单选
          isRequired: 1,
          isOther: 1,
          surveyFieldOptionList: [
            { name: '男', fieldId: 1, id: 1, sort: 1 },
            { name: '女', fieldId: 1, id: 2, sort: 2 }
          ],
          other: ''
        },
        {
          id: 2,
          rowId: 2,
          fieldName: '您喜欢的课程类型？',
          fieldCode: 'course_types',
          type: 2, // 多选
          isRequired: 1,
          isOther: 1,
          surveyFieldOptionList: [
            { name: '理论课', fieldId: 2, id: 3, sort: 1 },
            { name: '实践课', fieldId: 2, id: 4, sort: 2 },
            { name: '实训课', fieldId: 2, id: 5, sort: 3 }
          ],
          other: ''
        },
        {
          id: 3,
          rowId: 3,
          fieldName: '您的专业是？',
          fieldCode: 'major',
          type: 1, // 单选
          isRequired: 0,
          isOther: 1,
          surveyFieldOptionList: [
            { name: '计算机科学', fieldId: 3, id: 6, sort: 1 },
            { name: '机械工程', fieldId: 3, id: 7, sort: 2 }
          ],
          other: ''
        },
        {
          id: 4,
          rowId: 4,
          fieldName: '您对学校设施的评价',
          fieldCode: 'facility_rating',
          type: 5, // 矩阵单选
          isRequired: 1,
          isOther: 0,
          surveyFieldOptionList: [
            { name: '非常满意', fieldId: 4, id: 8, sort: 1 },
            { name: '满意', fieldId: 4, id: 9, sort: 2 },
            { name: '一般', fieldId: 4, id: 10, sort: 3 },
            { name: '不满意', fieldId: 4, id: 11, sort: 4 }
          ],
          surveyFieldMatrixDimensionList: [
            { name: '教室环境', id: 1, value: '' },
            { name: '图书馆设施', id: 2, value: '' },
            { name: '实验设备', id: 3, value: '' }
          ]
        }
      ];

      this.queryForm.formCode = 'mock_form';
      this.queryForm.formName = '测试问卷';
      this.processSurveyData(mockSurveyFormFieldInfoList);
    },

    // 处理问卷数据（提取公共逻辑）
    processSurveyData(surveyFormFieldInfoList) {
      // 先处理所有题目数据
      const processedList = surveyFormFieldInfoList.map(item => {
        // 是否其他
        if (item.isOther === 1) {
          item.other = '';
          item.surveyFieldOptionList.push({
            name: '其他',
            fieldId: item.id,
            id: Date.now(),
            sort: item.surveyFieldOptionList.length + 1
          });
        }

        // 是否必填
        if (item.isRequired) {
          this.rules[item.fieldCode] = [
            {
              required: true,
              message: `请填写${item.fieldName}`,
              trigger: 'blur'
            }
          ];
        }

        if (item.type === 2) {
          this.$set(this.ruleForm, item.fieldCode, []);
        }

        // 级联项获取字典
        if (item.type === 3) {
          this.$axios.get('/api' + item.port).then(response => {
            console.log('🚀 ~ response:', response);
            // 处理成功的响应
            this.option = response.data.data;
          });
        }
        // 矩阵单选题初始化
        if (item.type === 5) {
          this.$set(this.ruleForm, item.fieldCode, {});
          // 为每个维度初始化值
          if (item.surveyFieldMatrixDimensionList) {
            item.surveyFieldMatrixDimensionList.forEach((dimension, index) => {
              // 直接在 dimension 对象上设置 value 属性
              this.$set(dimension, 'value', '');
            });
          }
        }

        return item;
      });

      // 保存完整的题目列表
      this.allQuestions = processedList;

      // 初始化可见题目列表
      this.initVisibleQuestions();

      // 只保留可见的题目用于显示
      this.updateVisibleQuestions();
    },

    // 初始化可见题目
    initVisibleQuestions() {
      const visibleIds = [];

      this.allQuestions.forEach(item => {
        // 如果没有 showConditions 或为空数组，直接显示
        if (!item.showConditions || item.showConditions.length === 0) {
          visibleIds.push(item.rowId);
        }
      });
      this.visibleQuestionIds = visibleIds;
      this.surveyFormFieldInfoList = this.allQuestions.filter(item => visibleIds.includes(item.rowId));
    },

    // 更新可见题目列表
    updateVisibleQuestions() {
      const newVisibleIds = [];

      this.allQuestions.forEach(item => {
        if (!item.showConditions || item.showConditions.length === 0) {
          newVisibleIds.push(item.rowId);
        } else {
          const shouldShow = this.checkQuestionVisibility(item, this.allQuestions);
          if (shouldShow) {
            newVisibleIds.push(item.rowId);
          }
        }
      });
      // 如果可见题目有变化，更新显示列表
      const hasChanged = JSON.stringify(this.visibleQuestionIds.sort()) !== JSON.stringify(newVisibleIds.sort());
      if (hasChanged) {
        this.visibleQuestionIds = newVisibleIds;
        // 过滤出可见的题目
        this.surveyFormFieldInfoList = this.allQuestions.filter(item => newVisibleIds.includes(item.rowId));
      }
    },

    // 检查题目是否应该显示
    checkQuestionVisibility(targetItem, allQuestions) {
      if (!targetItem.showConditions || targetItem.showConditions.length === 0) {
        return true;
      }

      // 遍历所有显示条件
      for (let condition of targetItem.showConditions) {
        const { fieldId, selectedOptions } = condition;

        // 找到对应的题目
        const sourceQuestion = allQuestions.find(q => q.rowId === fieldId);
        if (!sourceQuestion) continue;

        // 获取该题目的已选值
        const selectedValue = this.ruleForm[sourceQuestion.fieldCode];

        if (!selectedValue) continue;

        // 判断是否匹配
        // 如果是数组（多选），检查是否有任一选项在 selectedOptions 中
        if (Array.isArray(selectedValue)) {
          const hasMatch = selectedValue.some(val => selectedOptions.some(opt => opt === val || opt.name === val));
          if (hasMatch) {
            return true;
          }
        } else {
          // 单选或其他类型，直接比较
          const hasMatch = selectedOptions.some(opt => opt === selectedValue || opt.name === selectedValue);
          if (hasMatch) {
            return true;
          }
        }
      }

      return false;
    },

    cascaderFocus(item, index) {
      this.ruleForm[item.fieldCode] = ' ';
      // this.surveyFormFieldInfoList[index] = ''
      this.$axios.get('/api' + item.port).then(response => {
        // 处理成功的响应
        this.surveyFormFieldInfoList[index].options = response.data.data;
        this.$forceUpdate();
      });
    },

    // 级联选择器改变时
    cascaderChange(value, item) {
      // 重新检查所有题目的可见性
      this.updateVisibleQuestions();
    },

    doClickSubmit() {
      let list = [];
      this.surveyFormFieldInfoList.map(item => {
        switch (item.type) {
          // 单选
          case 1:
            if (this.ruleForm[item.fieldCode] === '其他') {
              list.push({
                fieldCode: item.fieldCode,
                value: '其他：' + item.other
              });
              // 没有选择其他
            } else {
              list.push({
                fieldCode: item.fieldCode,
                value: this.ruleForm[item.fieldCode]
              });
            }
            break;
          // 多选
          case 2:
            const otherIndex = this.ruleForm[item.fieldCode].indexOf('其他');
            // '其他：' +  item.other
            if (otherIndex !== -1) {
              // 拿到'其他'在数组中的位置并拼接内容
              list.push({
                fieldCode: item.fieldCode,
                value: this.ruleForm[item.fieldCode].map((it, index) => {
                  if (otherIndex === index) {
                    it = '其他：' + item.other;
                  }
                  return it;
                })
              });
            } else {
              list.push({
                fieldCode: item.fieldCode,
                value: this.ruleForm[item.fieldCode]
              });
            }
            break;

          case 3:
            if (this.ruleForm[item.fieldCode] === '其他') {
              list.push({
                fieldCode: item.fieldCode,
                value: '其他：' + item.other
              });
            } else {
              let value = item.value[item.value.length - 1];
              list.push({
                fieldCode: item.fieldCode,
                value
              });
            }
            break;
          case 5:
            // 矩阵单选题，将每个维度的答案组装成数组
            const matrixValues = [];
            if (item.surveyFieldMatrixDimensionList) {
              item.surveyFieldMatrixDimensionList.forEach(dimension => {
                matrixValues.push({
                  name: dimension.name,
                  value: dimension.value || ''
                });
              });
            }
            list.push({
              fieldCode: item.fieldCode,
              value: JSON.stringify(matrixValues)
            });
            break;
          default:
            list.push({
              fieldCode: item.fieldCode,
              value: this.ruleForm[item.fieldCode]
            });
            break;
        }
      });

      // 验证"其他"选项的内容是否填写
      const otherError = this.surveyFormFieldInfoList.some(item => {
        // type 1: 单选
        if (item.type === 1 && this.ruleForm[item.fieldCode] === '其他') {
          if (!item.other || item.other.trim() === '') {
            this.$message.error(`请填写${item.fieldName}的其他选项内容`);
            return true;
          }
        }
        // type 2: 多选
        if (item.type === 2 && Array.isArray(this.ruleForm[item.fieldCode])) {
          const otherIndex = this.ruleForm[item.fieldCode].indexOf('其他');
          if (otherIndex !== -1) {
            if (!item.other || item.other.trim() === '') {
              this.$message.error(`请填写${item.fieldName}的其他选项内容`);
              return true;
            }
          }
        }
        // type 3: 级联
        if (item.type === 3 && this.ruleForm[item.fieldCode] === '其他') {
          if (!item.other || item.other.trim() === '') {
            this.$message.error(`请填写${item.fieldName}的其他选项内容`);
            return true;
          }
        }
        return false;
      });

      if (otherError) {
        return;
      }

      // 对 type 5 的题目进行特殊验证处理
      const hasError = this.surveyFormFieldInfoList.some(item => {
        if (item.type === 5 && item.isRequired && item.surveyFieldMatrixDimensionList) {
          // 检查每个维度的值
          for (let dimension of item.surveyFieldMatrixDimensionList) {
            if (!dimension.value || dimension.value.trim() === '') {
              this.$message.error(`请填写${item.fieldName} - ${dimension.name}`);
              return true;
            }
          }
        }
        return false;
      });

      if (hasError) {
        return;
      }

      this.queryForm.surveyFormDataList = list.map(item => {
        if (Array.isArray(item.value)) {
          return {
            fieldCode: item.fieldCode,
            value: JSON.stringify(item.value)
          };
        } else {
          return {
            ...item
          };
        }
      });
      this.$refs.ruleForm.validate(isValid => {
        if (isValid) {
          // 验证窗口
          this.dialogVisible = true;
          // 提交问卷
          // this.submitQuestionnaire();
        }
      });
    },

    // dialogBeforeClose() {
    //   this.dialogVisible = false;
    // },
    //提交问卷
    submitQuestionnaire() {
      setTimeout(() => {
        this.dialogVisible = false;
        // 验证组件初始化
        this.$refs.slideblock.$refs.slideblock.reset();
      }, 500);
      this.step2Loading = true;
      submit(this.queryForm)
        .then(res => {
          this.success = true;
          this.step2Loading = false;
          if (res.data.success) {
            this.step = 3;
          }
        })
        .catch(msg => {
          this.$message.error(msg);
          this.success = false;
          this.step2Loading = false;
        });
    },

    onSuccess(validate) {
      if (validate) {
        this.queryForm.verificationCode = validate;
        // console.log(this.$refs.slideblock, 'this.$refs.slideblock');
        //this.$message.success('验证通过');
        this.submitQuestionnaire();
      } else {
        this.$message.error('系统异常');
      }
    },
    onFail() {
      console.log(this.$refs.slideblock, '所有参数');
      console.log(this.$refs.slideblock.block_x, 'x轴');
      console.log(this.$refs.slideblock.block_y, 'Y轴');
      this.$message.error('验证失败 , 请重试!');
    },
    onRefresh() {
      console.log('点击了刷新小图标');
      this.msg = '';
    },
    onFulfilled() {
      console.log('刷新成功啦！');
    },
    onAgain() {
      console.log('检测到非人为操作的哦！');
      this.msg = 'try again';
      // 刷新
      this.$refs.slideblock.reset();
    },
    handleClick() {
      // 父组件直接可以调用刷新方法
      this.$refs.slideblock.reset();
    }
  }
};
</script>
<style>
.title {
  font-size: 30px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: bold;
  color: #2187f9;
}

.page {
  width: 100%;
  height: auto;
  background: linear-gradient(#2489f9, #fff);
  overflow: auto;
  text-align: center;
  padding: 60px 0px 100px 0px;
  /* box-sizing: border-box; */
  display: flex;
  justify-content: center;
  /* align-items: center; */
}

.container {
  padding: 20px 60px 20px 60px;
  width: 70%;
  overflow: hidden;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.el-input__inner {
  border: 0px;
  border-bottom: 1px solid #cccccc;
  border-radius: 0;
}

.demo-ruleForm {
  text-align: left;
}

.form-item {
  padding-bottom: 20px;
  border-bottom: 1px dashed #cccccc;
}

.matrix-question {
  width: 100%;
  overflow-x: auto;
}

.matrix-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.matrix-table th,
.matrix-table td {
  border: 1px solid #e0e0e0;
  padding: 12px 8px;
}

.matrix-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #333;
}

.matrix-table .dimension-name {
  text-align: center;
  font-weight: 500;
  color: #606266;
}

.matrix-table td {
  text-align: center;
}

.radio-option {
  display: inline-block;
  width: auto;
  max-width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

.radio-option .el-radio__label {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/view/answer/index.vue